import { displayRequestEducationTable } from "./display-request-education-table";
import {
  acceptEducationRequest,
  findEducationRequest,
} from "../../infrastructure/repository/request-repository";
import { showSuccessMessage } from "../commons/show-success-message";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { hideModal } from "../commons/hide-modal";
import { translate } from "../../infrastructure/translate/localization";
import { findCompanyId } from "../../infrastructure/repository/company-repository";

export async function acceptEducation(
  { splitBy, centsInPayroll, centsAmountFromFunds, requestId } = {
    splitBy: undefined,
  }
) {
  try {
    const companyId = await findCompanyId();
    await acceptEducationRequest({
      splitBy,
      centsInPayroll,
      centsAmountFromFunds,
      requestId,
      companyId,
    });
    addContextLog("info", "acceptEducationRequest", "request", {
      splitBy,
      centsInPayroll,
      centsAmountFromFunds,
      requestId,
      companyId,
    });

    const { data: requests } = await findEducationRequest({ companyId });
    displayRequestEducationTable({ requests, isLoading: false });

    hideModal();
    showSuccessMessage(translate("request-section.request-success"));
  } catch (e) {
    const errorMessage = e?.response?.data?.code;
    logError(e, `Error to acceptEducationRequest of ${requestId}`);
    showErrorMessage(
      `Error: ${translate(
        errorMessage
          ? `errors.${e?.response?.data?.code}`
          : "common-messages.basic-error-message"
      )}`,
      true,
      errorMessage
    );
  }
}
